import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Sum from './pages/Sum';
import Compare from './pages/Compare';
import Sumresult from './pages/Sumresult';
import Compres from './pages/CompareResult';
import Visual from './pages/Visual';
import Visualres from './pages/visualres';
import Load_sum from './pages/Load_sum';
import Load_com from './pages/Load_com';
import Load_visual from './pages/Load_visual';
import Login from './login/Login';
import Signup from './login/Signup';
import Home from './com/Home';
// import Profile from './pages/Profile';
// import Otpverification from './pages/Otpverification';
// import ProtectedRoute from './com/ProtectedRoute';
// import Profile_customer from './pages/Profile_cust';
// import Profile_seller from './pages/Profile_sell';
// import Wishlist from './pages/Wishlist';
import PriceTrackerGraph from './pages/Pricetracker';

// // Create role-specific route components
// const SellerRoute = ({ children }) => {
//   const token = localStorage.getItem('token');
//   const decodedToken = token ? JSON.parse(atob(token.split('.')[1])) : null;
  
//   if (!token || !decodedToken) {
//     return <Navigate to="/login" />;
//   }
  
//   if (decodedToken.role !== 'seller') {
//     return <Navigate to="/profile" />;
//   }
  
//   return children;
// };

// const CustomerRoute = ({ children }) => {
//   const token = localStorage.getItem('token');
//   const decodedToken = token ? JSON.parse(atob(token.split('.')[1])) : null;
  
//   if (!token || !decodedToken) {
//     return <Navigate to="/login" />;
//   }
  
//   if (decodedToken.role !== 'customer') {
//     return <Navigate to="/profile" />;
//   }
  
//   return children;
// };

// // AppContent component that uses useLocation
// function AppContent() {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userRole, setUserRole] = useState('');
//   const location = useLocation();

//   useEffect(() => {
//     // Check authentication status and role
//     const token = localStorage.getItem('token');
//     const role = localStorage.getItem('userRole');
//     setIsLoggedIn(!!token);
//     setUserRole(role || '');
//   }, [location.pathname]);

//   return (
//     <>
//       {/* Show Nav based on auth status */}
//       {location.pathname !== '/login' && 
//        location.pathname !== '/signup' && 
//        location.pathname !== '/otp' && 
//        (isLoggedIn)}

//       <Routes>
//         {/* Public Routes */}
//         <Route path="/" element={<Home />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/signup" element={<Signup />} />
//         <Route path="/otp" element={<Otpverification />} />
        
//         {/* Common Routes - Accessible to all */}
//         <Route path="/summarize" element={<Sum />} />
//         <Route path="/compare" element={<Compare />} />
//         <Route path="/visual" element={<Visual />} />
//         <Route path="/pricetra" element={<PriceTrackerGraph />} />

//         {/* Protected Routes */}
//         <Route path="/profile" element={
//           <ProtectedRoute>
//             <Profile />
//           </ProtectedRoute>
//         } />

//         {/* Seller Profile Route */}
//         <Route path="/profile-seller" element={
//           <SellerRoute>
//             <Profile_seller />
//           </SellerRoute>
//         } />
        
//         {/* Customer Profile Route */}
//         <Route path="/profile-customer" element={
//           <CustomerRoute>
//             <Profile_customer />
//           </CustomerRoute>
//         } />
      
//         {/* Customer-only Routes */}
//         <Route path="/sumresult" element={
//           <ProtectedRoute>
//             <Sumresult />
//           </ProtectedRoute>
//         } />

//         <Route path="/compres" element={
//           <ProtectedRoute>
//             <Compres />
//           </ProtectedRoute>
//         } />

//         <Route path="/load_sum" element={
//           <ProtectedRoute>
//             <Load_sum />
//           </ProtectedRoute>
//         } />

//         <Route path="/load_com" element={
//           <ProtectedRoute>
//             <Load_com />
//           </ProtectedRoute>
//         } />

//         <Route path="/wishlist" element={
//           <CustomerRoute>
//             <Wishlist />
//           </CustomerRoute>
//         } />

//         {/* Seller-only Routes */}
//         <Route path="/load_visual" element={
//           <ProtectedRoute>
//             <Load_visual />
//           </ProtectedRoute>
//         } />

//         {/* Customer Profile Route */}
//         <Route path="/pricetra" element={
//           <CustomerRoute>
//             <PriceTrackerGraph />
//           </CustomerRoute>
//         } />

//         <Route path="/visualres" element={
//           <ProtectedRoute>
//             <Visualres />
//           </ProtectedRoute>
//         } />

//         {/* Catch all - redirect to home */}
//         <Route path="*" element={<Navigate to="/" />} />
//       </Routes>
//     </>
//   );
// }

// // Main App component wrapped with Router
// function App() {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// }

// export default App;

// // import React,{useState,useEffect} from 'react';
// // import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// // import Sum from './pages/Sum';
// // import Compare from './pages/Compare';
// // import Sumresult from './pages/Sumresult'; 
import Nav from './pages/Nav';
// // import Compres from './pages/CompareResult';
// // import ComparePrices from './pages/Pricecomp';
// // import Load_com from './pages/Load_com';
// // import Load_sum from './pages/Load_sum';
// // import Visual from './pages/Visual';
// // import Load_visual from './pages/Load_visual';
// // import Visualres from './pages/visualres';
// // import Home from './com/Home';
// // import First from './com/First'
// // import Login from './login/Login'
// // import Signup from './login/Signup';
// // import Main from './pages/katre';
// // import VisualShowcaseContainer from './com/exp';



  
function App() {
  const [chartData, setChartData] = useState(null);

  return (
    <Router>
      <Layout />
      {/* <Visualres data={chartData}/> */}
    </Router>
  );
}

function Layout() {
  const loc = useLocation();

  return (
    <>
      {/*  Navbar based on pathname */}
      {/* {loc.pathname !== '/summarize' && loc.pathname!=='/compare' &&loc.pathname!=='/visual' && loc.pathname!=='/'&& loc.pathname!=='/login' && loc.pathname!=='/signup' && loc.pathname !== '/load_sum' && loc.pathname !== '/load_com' && loc.pathname !== '/load_visual' &&  <Nav />} */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/summarize" element={<Sum />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/sumresult" element={<Sumresult />} />
        <Route path="/compres" element={<Compres />} />
        <Route path="/load_sum" element={<Load_sum />} />
        <Route path="/load_com" element={<Load_com />} />
        <Route path="/visual" element={<Visual />} />
        <Route path="/load_visual" element={<Load_visual />} />
        <Route path='/visualres' element={<Visualres/>} />
        <Route path='/login' element={<Login/>} />
        <Route path='/signup' element={<Signup/>} />
        <Route path='/pricetra' element={<PriceTrackerGraph/>}/>




        </Routes>

    </>
  );
}

export default App;
